import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import DisposeReadonlyValue from './dispose-readonly-value.vue'
import { ApplyScope } from '../constants/enums'
import { listCol } from '@/utils/list-columns-i18n'
import { PARSE_STATUS_COLOR_MAP } from '../security-event-detail.mapper'
import type { SecurityEventDetail } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'dispose-file-context-form',
  props: {
    detail: {},
    showApplyScope: { type: Boolean },
    applyScope: {}
  },
  emits: ["update:applyScope"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()

const fileNameDisplay = computed(() => {
  return (
    props.detail.file_name ||
    props.detail.file_path?.split(/[/\\]/).pop() ||
    props.detail.threat_entity?.split(/[/\\]/).pop() ||
    undefined
  )
})

const filePathDisplay = computed(
  () => props.detail.file_path ?? props.detail.threat_entity,
)

const threatStatusColor = computed(() => {
  const raw = props.detail.file_threat_status
  if (!raw) return undefined
  return PARSE_STATUS_COLOR_MAP[raw] || undefined
})

const threatStatusDisplay = computed(() => {
  const raw = props.detail.file_threat_status
  if (!raw) return t('securityEvent.threatStatusUnknown')
  // cloud_status 存储的是 i18n key（如 parseStatus.knownSafe 或 securityEvent.scanResult.1），需要 t() 翻译
  return (raw.startsWith('securityEvent.') || raw.startsWith('parseStatus.')) ? t(raw) : raw
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "left",
    "label-width": "auto",
    size: "small",
    class: "dispose-form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('securityEvent.labelFileName')
      }, {
        default: _withCtx(() => [
          _createVNode(DisposeReadonlyValue, { value: fileNameDisplay.value }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('securityEvent.labelThreatStatus')
      }, {
        default: _withCtx(() => [
          (threatStatusColor.value)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                size: "small",
                style: _normalizeStyle(`background-color: ${threatStatusColor.value}1a;border: 1px solid ${threatStatusColor.value};color:${threatStatusColor.value}`)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(threatStatusDisplay.value), 1)
                ]),
                _: 1
              }, 8, ["style"]))
            : (_openBlock(), _createBlock(DisposeReadonlyValue, {
                key: 1,
                value: threatStatusDisplay.value
              }, null, 8, ["value"]))
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _unref(listCol)(_unref(t), 'filePath')
      }, {
        default: _withCtx(() => [
          _createVNode(DisposeReadonlyValue, {
            value: filePathDisplay.value,
            multiline: ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$t('securityEvent.labelFileMd5')
      }, {
        default: _withCtx(() => [
          _createVNode(DisposeReadonlyValue, {
            value: _ctx.detail.file_md5,
            multiline: ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.showApplyScope)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _ctx.$t('securityEvent.applyScope')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                "model-value": _ctx.applyScope,
                size: "small",
                style: {"width":"240px"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:applyScope', $event)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('securityEvent.scopeLocal'),
                    value: _unref(ApplyScope).Local
                  }, null, 8, ["label", "value"]),
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('securityEvent.scopeAll'),
                    value: _unref(ApplyScope).AllEndpoints
                  }, null, 8, ["label", "value"])
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})